const DateTimeCell = ({ value, showTime = true }) => {
    if (!value) {
        return <span className="text-sm text-gray-400">-</span>;
    }

    const date = new Date(value);

    const formattedDate = new Intl.DateTimeFormat("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    }).format(date);

    const formattedTime = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    }).format(date);

    return (
        <div className="leading-tight">
            <span className="block text-sm font-medium text-gray-900">
                {formattedDate}
            </span>

            {showTime && (
                <span className="block text-sm text-gray-500">
                    {formattedTime}
                </span>
            )}
        </div>
    );
};

export default DateTimeCell;
